import React from 'react';
import {
  TableCell,
  Tooltip,
  IconButton,
  TableRow
} from '@material-ui/core';
import { format } from 'date-fns';
import { TextFormattedNumber } from 'components';
import { EditIcon } from 'components/CustomSVG';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { subscriptionStatus } from 'helpers/customerSubscriptions';
import { useHistory } from 'react-router';


const SubscriptionsRowCollapsible = ({customerSubscriptionsData, headTableCells}) => {
  const history = useHistory();
  const {
    increment_id,
    description,
    status,
    extension_attributes: {
      first_name,
      last_name
    },
    created_at,
    last_run,
    next_run,
    run_count,
    subtotal,
    id

  } = customerSubscriptionsData;
  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const createdAtdate = convertUTCDateToLocalDate(created_at);
  const lastRundate = convertUTCDateToLocalDate(last_run);
  const nextRundate = convertUTCDateToLocalDate(next_run);

  return (
    <TableRow>
      {columns['Id']?.display && <TableCell width="10%">{increment_id}</TableCell>}
      {columns['Description']?.display && <TableCell>{description}</TableCell>}
      {columns['Status']?.display && <TableCell>{subscriptionStatus[status]}</TableCell>}
      {columns['First Name']?.display && <TableCell>{first_name}</TableCell>}
      {columns['Last Name']?.display && <TableCell>{last_name}</TableCell>}
      {columns['Created']?.display &&
        <TableCell width="10%">
          <div>{format(createdAtdate, 'MM/dd/yyyy')}</div>
          <div>{format(createdAtdate, 'hh:mm:ss aa')}</div>
        </TableCell>
      }
      {columns['Last Run']?.display &&
        <TableCell width="10%">
          <div>{format(lastRundate, 'MM/dd/yyyy')}</div>
          <div>{format(lastRundate, 'hh:mm:ss aa')}</div>
        </TableCell>
      }
      {columns['Next Run']?.display &&
        <TableCell width="10%">
          <div>{format(nextRundate, 'MM/dd/yyyy')}</div>
          <div>{format(nextRundate, 'hh:mm:ss aa')}</div>
        </TableCell>
      }
      {columns['Times Billed']?.display && <TableCell>{run_count}</TableCell>}
      {columns['Subtotal']?.display &&
        <TableCell>
          <TextFormattedNumber
            value={subtotal}
            prefix="$"
          />
        </TableCell>}
      {columns['Action']?.display &&
        <TableCell>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => history.push(`/subscriptions/edit/${id}/${increment_id}`, { params: history.location.search })}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      }
    </TableRow>
  );
};

export default SubscriptionsRowCollapsible;
